import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

/* What learners see after a microreel: a knowledge check or a policy attestation (EndingEditor). */

const english = {
  // An incomplete ending, said when it is saved.
  correctAnswerBlank:
    'The correct answer cannot be blank. Choose a completed option.',
  fillAllOptions: 'Fill in all four answer options.',
  enterQuestion: 'Enter a question.',
  enterStatement: 'Enter an attestation statement.',

  fixBeforePublishing: 'Fix before publishing',
  stillGenerated: ' · the microreel can still be generated',
  renderSavesHint:
    'Not required before rendering. Unsaved changes are saved with the render.',
  saving: 'Saving…',
  titled: (heading: string, reelTitle?: string) =>
    reelTitle ? `${heading} · ${reelTitle}` : heading,

  // A policy attestation.
  policyAttestation: 'Policy attestation',
  attestationLead: 'Shown after the video; the learner confirms it in Tapybl.',
  attestationPlaceholder:
    'I have read and understood the … procedure and will follow it.',
  saveAttestation: 'Save attestation',

  // A knowledge check.
  knowledgeCheck: 'Knowledge check',
  questionLead: 'Shown after the video; sent to Tapybl with the microreel.',
  generating: 'Generating…',
  generateFrom: (video: boolean) =>
    `Generate from ${video ? 'video' : 'document'}`,
  generateWithAi: 'Generate with AI',
  generateHint: (source: 'video' | 'document' | null) =>
    `Drafts a question and answers${
      source ? ` from your ${source}` : ''
    }. Uses AI credits; review it, then save.`,
  question: 'Question',
  questionPlaceholder: 'A short scenario that ends in a question',
  options: 'Options · one correct',
  answerOption: (letter: string) => `Answer option ${letter}`,
  optionPlaceholder: (letter: string) => `Option ${letter}`,
  correctAnswer: 'Correct answer',
  feedback: 'Feedback shown after answering',
  feedbackPlaceholder: 'Why the correct option is right',
  saveKnowledgeCheck: 'Save knowledge check',
};

const welsh: typeof english = {
  correctAnswerBlank:
    'Ni all yr ateb cywir fod yn wag. Dewiswch opsiwn sydd wedi’i lenwi.',
  fillAllOptions: 'Llenwch bob un o’r pedwar opsiwn ateb.',
  enterQuestion: 'Rhowch gwestiwn.',
  enterStatement: 'Rhowch ddatganiad i’w gadarnhau.',

  fixBeforePublishing: 'Trwsiwch cyn cyhoeddi',
  stillGenerated: ' · gellir cynhyrchu’r microreel o hyd',
  renderSavesHint:
    'Nid oes ei angen cyn rendro. Mae newidiadau heb eu cadw yn cael eu cadw gyda’r rendro.',
  saving: 'Yn cadw…',
  titled: (heading: string, reelTitle?: string) =>
    reelTitle ? `${heading} · ${reelTitle}` : heading,

  policyAttestation: 'Datganiad polisi',
  attestationLead:
    'Yn cael ei ddangos ar ôl y fideo; mae’r dysgwr yn ei gadarnhau yn Tapybl.',
  attestationPlaceholder:
    'Rwyf wedi darllen a deall y weithdrefn … a byddaf yn ei dilyn.',
  saveAttestation: 'Cadw’r datganiad',

  knowledgeCheck: 'Gwiriad gwybodaeth',
  questionLead:
    'Yn cael ei ddangos ar ôl y fideo; yn cael ei anfon i Tapybl gyda’r microreel.',
  generating: 'Yn cynhyrchu…',
  generateFrom: (video: boolean) =>
    `Cynhyrchu o’r ${video ? 'fideo' : 'ddogfen'}`,
  generateWithAi: 'Cynhyrchu gydag AI',
  generateHint: (source: 'video' | 'document' | null) =>
    `Yn drafftio cwestiwn ac atebion${
      source ? ` o’ch ${source === 'video' ? 'fideo' : 'dogfen'}` : ''
    }. Yn defnyddio credydau AI; adolygwch ef, yna cadwch ef.`,
  question: 'Cwestiwn',
  questionPlaceholder: 'Senario byr sy’n gorffen gyda chwestiwn',
  options: 'Opsiynau · un yn gywir',
  answerOption: (letter: string) => `Opsiwn ateb ${letter}`,
  optionPlaceholder: (letter: string) => `Opsiwn ${letter}`,
  correctAnswer: 'Yr ateb cywir',
  feedback: 'Adborth a ddangosir ar ôl ateb',
  feedbackPlaceholder: 'Pam mae’r opsiwn cywir yn gywir',
  saveKnowledgeCheck: 'Cadw’r gwiriad gwybodaeth',
};

export const endingEditorText: typeof english = getLocalizationBasedOnLang(
  english,
  welsh,
);
